import { all } from 'redux-saga/effects'
import reportProvidersSaga from './reportProviders'
import reportProviderSaga from './reportProvider'

function* powerBIReportProvidersSaga() {
  yield all([reportProvidersSaga(), reportProviderSaga()])
}

export default powerBIReportProvidersSaga
